import React, { useEffect } from 'react';
import TpLayout from './TpLayout';
import { NavigatingAway, useNavigation } from './TpNavigation';
import Sidebar from '../Sidebar/Sidebar';
import TpMap from '../Map';
import { useTp } from '../context/TpContext';
import { tpMemoryManager } from '../utils/memoryManager';

/**
 * Main TP page component
 * Uses Context to get state
 */
export default function TpPage() {
  // Get required state from context
  const { 
    showPanel,
    setShowPanel
  } = useTp();
  
  // Use navigation service
  const { goToHome, isMountedRef, isNavigatingRef } = useNavigation();
  
  // Component mount/unmount handling + Memory Management
  useEffect(() => {
    isMountedRef.current = true;
    isNavigatingRef.current = false;
    
    // Initialize memory management
    tpMemoryManager.initialize();
    
    return () => {
      isMountedRef.current = false;
      // Cleanup memory management
      tpMemoryManager.cleanup();
    };
  }, [isMountedRef, isNavigatingRef]);

  // Check if navigating away
  if (isNavigatingRef.current) {
    return <NavigatingAway />;
  }

  // Sidebar component - now using Context internally
  const sidebarComponent = <Sidebar />;

  // Map component - now using Context internally
  const mapComponent = <TpMap />;

  return (
            <TpLayout
      showPanel={showPanel}
      setShowPanel={setShowPanel}
      goToHome={goToHome}
      sidebar={sidebarComponent}
      map={mapComponent}
    />
  );
} 